import * as React from 'react'

import * as H from 'history'
import { RouteConfig } from 'react-router-config'
import { Store } from 'redux'

import { isEqual } from 'lodash'
import * as querystring from 'query-string'
import { Route, RouteComponentProps, withRouter } from 'react-router-dom'
import * as url from 'url'

import { resetAlerts, resetErrorPage } from '../../common/actions/common'
import { setUserSearchResultsViewType } from '../../common/actions/user/preference'
import { searchApiParams } from '../../common/constants/searchQueryWhitelist'
import { reportPageView } from '../../common/utils/analytics'
import fetchAllRequest from '../../common/utils/fetchAllRequest'
import ga from '../../common/utils/ga'
import objectDiff from '../../common/utils/objectDiff'
import { countSearchFor } from '../../common/utils/tracking/trackSearchCount'
import { parseLocation } from '../../common/utils/urlHelper'

import { IRootState } from '../../common/reducers'

const shouldFetchData = (
  previousLocation: H.Location,
  newLoaction: H.Location
) => {
  const previousParsedLocationQuery = parseLocation({
    pathname: previousLocation.pathname,
    query: querystring.parse(previousLocation.search)
  })
  const newParsedLocationQuery = parseLocation({
    pathname: newLoaction.pathname,
    query: querystring.parse(newLoaction.search)
  })

  return objectDiff(previousParsedLocationQuery, newParsedLocationQuery).some(
    key => searchApiParams.includes(key)
  )
}

interface IProps extends RouteComponentProps<any> {
  store: Store<IRootState>
  routes: RouteConfig[]
}

class PendingNavDataLoader extends React.Component<IProps> {
  public componentWillReceiveProps(nextProps: IProps) {
    // check whether url has changed
    const navigated = !isEqual(nextProps.location, this.props.location)
    const { store, routes } = this.props

    const newLocationQuery = querystring.parse(nextProps.location.search)

    if (navigated) {
      // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overriding
      ga('set', 'location', window.location.href)

      // Reset / hide alerts when changing the route after first rendering
      if (store.getState().common.alerts.length) {
        store.dispatch(resetAlerts())
      }

      // Reset (remove) error page if present
      if (store.getState().common.errorPage) {
        store.dispatch(resetErrorPage())
      }

      if (typeof window !== 'undefined' && newLocationQuery.view) {
        store.dispatch(setUserSearchResultsViewType(newLocationQuery.view))
      }

      if (shouldFetchData(this.props.location, nextProps.location)) {
        // we have to ge the full location because `matchRoutes` does not return the search query part
        const opts = {
          baseUrl: '',
          isServer: false
        }
        const parsedUrl = url.parse(window.location.href)
        const promiseRequests = fetchAllRequest(store, parsedUrl, routes, opts)
        const currentSite = this.props.store.getState().common.currentSite

        Promise.all(promiseRequests)
          .then(results => {
            reportPageView()
            if (currentSite === 'photodune') {
              countSearchFor(currentSite)
            }
          })
          .catch(() => {
            reportPageView()
          })
      }
    }
  }

  public render() {
    const { children, location } = this.props

    return <Route location={location} render={() => children} />
  }
}

export default withRouter<IProps>(PendingNavDataLoader)



// WEBPACK FOOTER //
// ./client/components/pendingNavDataLoader.tsx